import React, { useState, useRef } from "react";

import UploadDocument from "./comp/UploadDocument";
import { darkScrollbar } from "@mui/material";
import Header from "../../Header/Header";
import { useLocation, useNavigate } from "react-router-dom";
import ProgressBar from "../../../components/ProgressBar";
import { showErrorToast } from "../../utils";

const UploadAndReviewDoc = () => {
    const navigate = useNavigate();
    const [check, setCheck] = useState(1);
    const [formData, setFormData] = useState({});
    const [selectedSide, setSelectedSide] = useState("Front side");
    const backInputRef = useRef(null);
    const frontInputRef = useRef(null);
    const location = useLocation();
    const idType = location.state.idType;

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        file;
    };

    const handleFileUpload = (file, name) => {
        if (file) {
            darkScrollbar;
            const reader = new FileReader();
            reader.onload = (e) => {
                setFormData((prev) => ({
                    ...prev,
                    [name]: e.target.result,
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRetake = () => {
        // If both sides have images, show confirmation modal
        setCheck(1);
        if (formData.frontSide && formData.backSide) {
            if (window.confirm("Do you want to retake images?")) {
                setFormData((prev) => ({
                    ...prev,
                    frontSide: null,
                    backSide: null,
                }));
            } else {
            }
        } else {
            // If only one side has image, clear that side

            setFormData((prev) => ({
                ...prev,
                frontSide: null,
                backSide: null,
            }));
        }
        // Focus on the side that needs to be retaken
        // frontInputRef.current?.click();
    };

    const validateForm = () => {
        if (!formData.frontSide || !formData.backSide) {
            showErrorToast("Please upload an image of both sides of the ID", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            return false;
        }

        return true;
    };

    const handleUploadDocNext = () => {
        if (!validateForm()) {
            return;
        } else {
            // localStorage.setItem("documents", JSON.stringify(formData));
            navigate("/verify/step-3", {
                state: {
                    idType,
                    documents: { ...formData },
                },
            });
        }
    };

    return (
        <div className="tw-w-full tw-h-screen tw-bg-background_color tw-overflow-y-auto tw-pt-[70px] tw-flex tw-flex-col tw-justify-between tw-items-center tw-px-4 max-sm:tw-px-2">
            <Header title={"Identity Verification"} />
            <ProgressBar currentStep={2} totalSteps={3} />

            {check == 1 && (
                <UploadDocument
                    handleNext={handleUploadDocNext}
                    handleFileUpload={handleFileUpload}
                    handleDrop={handleDrop}
                    selectedSide={selectedSide}
                    setSelectedSide={setSelectedSide}
                    frontInputRef={frontInputRef}
                    backInputRef={backInputRef}
                    setCheck={setCheck}
                    setFormData={setFormData}
                    formData={formData}
                    handleRetake={handleRetake}
                />
            )}

            <div></div>
        </div>
    );
};

export default UploadAndReviewDoc;
